import * as GC from '@grapecity/spread-sheets';
import { spreadsheetConfig } from '@shared/spreadsheet/spreadsheet-config';

const defaultBookOptions = <GC.Spread.Sheets.IWorkbookOptions>{
  backColor: spreadsheetConfig.backColor,
  grayAreaBackColor: spreadsheetConfig.grayAreaBackColor,
  highlightInvalidData: true,
  allowContextMenu: true,
  allowCopyPasteExcelStyle: true,
  allowExtendPasteRange: false,
  allowUserDragDrop: false,
  allowUserEditFormula: false,
  enableFormulaTextbox: false,
  newTabVisible: false,
  tabStripVisible: false,
  allowUndo: true,
  tabNavigationVisible: false,
  scrollbarMaxAlign: true,
  scrollbarShowMax: true,
  scrollIgnoreHidden: true,
  showHorizontalScrollbar: true,
  defaultDragFillType: GC.Spread.Sheets.Fill.AutoFillType.copyCells,
  showScrollTip: GC.Spread.Sheets.ShowScrollTip.none,
  autoFitType: GC.Spread.Sheets.AutoFitType.cellWithHeader
};

const defaultSheetOptions = {
  clipBoardOptions: GC.Spread.Sheets.ClipboardPasteOptions.values
};

export const setDefaultBookOptions = (options: GC.Spread.Sheets.IWorkbookOptions, overrideOptions?) => {
  const mergedOptions: GC.Spread.Sheets.IWorkbookOptions = <GC.Spread.Sheets.IWorkbookOptions>{
    ...defaultBookOptions,
    ...overrideOptions
  };
  // Sheet back color
  options.backColor = mergedOptions['backColor'];
  // Display gray area color
  options.grayAreaBackColor = mergedOptions['grayAreaBackColor'];
  // Highlight invalid cells
  options.highlightInvalidData = mergedOptions['highlightInvalidData'];
  // Whether the user can copy style from Spread Sheets then paste to Excel,
  // or copy style from Excel then paste to Spread Sheets
  options.allowCopyPasteExcelStyle = mergedOptions['allowCopyPasteExcelStyle'];
  // Whether extend paste range if the paste range is not enough for pasting
  options.allowExtendPasteRange = mergedOptions['allowExtendPasteRange'];
  // Wheter user can drag and drop values
  options.allowUserDragDrop = mergedOptions['allowUserDragDrop'];
  // Whether the user can edit formulas in a cell in the spreadsheet
  options.allowUserEditFormula = mergedOptions['allowUserEditFormula'];
  // Whether to enable the formula text box in the spreadsheet
  options.enableFormulaTextbox = mergedOptions['enableFormulaTextbox'];
  // Whether the spreadsheet displays the special tab to let users insert new sheets
  options.newTabVisible = mergedOptions['newTabVisible'];
  // Whether to display the sheet tab strip
  options.tabStripVisible = mergedOptions['tabStripVisible'];
  // Enable the context menu
  options.allowContextMenu = mergedOptions['allowContextMenu'];
  // Enable Undo option
  options.allowUndo = mergedOptions['allowUndo'];

  // Other
  options.defaultDragFillType = mergedOptions['defaultDragFillType'];
  options.tabNavigationVisible = mergedOptions['tabNavigationVisible'];
  // ---------------------------------------------------------------------
  //   As per GrapeCity Support Mail 1
  // ---------------------------------------------------------------------
  options.autoFitType = mergedOptions['autoFitType'];
  options.scrollbarMaxAlign = mergedOptions['scrollbarMaxAlign'];
  options.scrollbarShowMax = mergedOptions['scrollbarShowMax'];
  options.scrollIgnoreHidden = mergedOptions['scrollIgnoreHidden'];
  options.showHorizontalScrollbar = mergedOptions['showHorizontalScrollbar'];
};

export const setDefaultSheetOptions = (options: GC.Spread.Sheets.IWorksheetOptions, overrideOptions?) => {
  const mergedOptions: GC.Spread.Sheets.IWorkbookOptions = <GC.Spread.Sheets.IWorkbookOptions>{
    ...defaultSheetOptions,
    ...overrideOptions
  };
  options.clipBoardOptions = mergedOptions['clipBoardOptions'];
};
